/**
 * This behavior is used in all widget view.js files except single_photo_view.js
 * which implements a modified version of this behavior.
 * Changes here may require changes in that file.
 */
Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette) {
    Behaviors.UpdateThumbnailCss = Marionette.Behavior.extend({
        ui: {
            imgHolder: '.img_holder'
        },
        onShow: function() {
            // Set background CSS properties for image holders based on viewport data
            var viewport = this.view.model.get('viewport');
            var backgroundCss = Pixlee.getViewportBackgroundDimensions(viewport);

            this.ui.imgHolder.css({
                'background-position': backgroundCss.backgroundPosition,
                'background-size': backgroundCss.backgroundSize
            });
        }
    });
});
